var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruiit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 111,
    viewBox: "0 0 98 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designer-rafiki"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M72.851 22.1522C71.7372 21.0379 71.7372 19.2359 72.851 18.1216L74.2075 16.7699C75.3258 15.66 77.1342 15.66 78.2525 16.7699C79.3622 17.8846 79.3622 19.6824 78.2525 20.7971L76.8926 22.1522C75.7739 23.2579 73.9697 23.2579 72.851 22.1522Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.4,
    d: "M72.851 22.1522C71.7372 21.0379 71.7372 19.2359 72.851 18.1216L74.2075 16.7699C75.3258 15.66 77.1342 15.66 78.2525 16.7699C79.3622 17.8846 79.3622 19.6824 78.2525 20.7971L76.8926 22.1522C75.7739 23.2579 73.9697 23.2579 72.851 22.1522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M74.7612 20.2599C73.3231 18.8233 73.3231 16.4979 74.7612 15.0613L77.4185 12.4135C78.8602 10.9805 81.1939 10.9805 82.6356 12.4135C84.0756 13.8493 84.0756 16.1762 82.6356 17.6121L79.9714 20.2599C78.5289 21.6845 76.2037 21.6845 74.7612 20.2599Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M78.4681 16.5554C76.0096 14.1181 72.0367 14.1181 69.5781 16.5554L78.4681 25.4172C80.9127 22.9655 80.9127 19.0072 78.4681 16.5554Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M82.0707 33.7385C81.7729 33.7385 81.5315 33.498 81.5315 33.2013C81.5315 32.9046 81.7729 32.6641 82.0707 32.6641C87.4492 32.6641 91.8093 28.3195 91.8093 22.9601C91.8093 17.6007 87.4492 13.2561 82.0707 13.2561C81.8683 13.2723 81.674 13.174 81.5679 13.0016C81.4617 12.8292 81.4617 12.6121 81.5679 12.4397C81.674 12.2673 81.8683 12.169 82.0707 12.1852C85.9808 12.1153 89.6242 14.1539 91.5998 17.517C93.5754 20.88 93.5754 25.0437 91.5998 28.4067C89.6242 31.7698 85.9808 33.8084 82.0707 33.7385Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8836 48.4539L95.189 106.678L95.7977 106.661L95.6829 108.331H67.5869L67.726 106.283H69.6216L69.5972 106.661H78.0873L87.6277 79.1219L81.2384 48.9009L82.8836 48.4539ZM93.452 106.678L87.8871 80.2939L78.7327 106.678H93.452Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6176 48.4698L33.9092 106.676H34.5179L34.4031 108.347H6.31055L6.44619 106.299H8.34523L8.3174 106.676H16.8179L26.3583 79.1379L19.9725 48.9169L21.6176 48.4698ZM32.1696 106.676L26.6046 80.2919L17.4434 106.676H32.1696Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M88.495 77.3674L86.9125 81.9318H25.792L27.371 77.3674H88.495Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M86.0853 80.8091L86.9096 81.932H25.7892L24.9648 80.8091H86.0853Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    opacity: 0.2,
    d: "M86.0853 80.8091L86.9096 81.932H25.7892L24.9648 80.8091H86.0853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M76.254 70.3293H1.60024L0.518555 69.2549L96.6217 28.5189L97.6999 29.5933L76.254 70.3293Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    opacity: 0.4,
    d: "M76.254 70.3293H1.60024L0.518555 69.2549L96.6217 28.5189L97.6999 29.5933L76.254 70.3293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M11.0983 46.5515L13.1699 42.6132L13.4779 42.7741L11.4064 46.7124L11.0983 46.5515Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M9.42994 49.7171L10.4148 47.8446L10.7229 48.0055L9.738 49.878L9.42994 49.7171Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M75.1723 69.2549H0.518555L21.9679 28.5189H96.6217L75.1723 69.2549Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    opacity: 0.3,
    d: "M67.6638 62.7218L14.8281 62.9089L30.4587 33.7761C42.9798 34.6703 61.7336 34.7535 82.2474 34.348L67.6638 62.7218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M66.9053 62.9088H14.5322L29.5784 34.3305C45.7098 34.9266 62.9855 34.5454 81.5933 34.0325C78.7099 41.2342 73.4789 51.6833 66.9053 62.9088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M23.7577 59.5408C28.6804 59.5131 33.603 59.49 38.5257 59.4715L54.3684 59.3987L62.3228 59.3606C62.3885 59.35 62.4368 59.2935 62.4368 59.2272C62.4368 59.1609 62.3885 59.1043 62.3228 59.0938L47.5548 59.1631L31.7121 59.2324L23.7577 59.2705C23.6828 59.2705 23.6221 59.331 23.6221 59.4057C23.6221 59.4803 23.6828 59.5408 23.7577 59.5408Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M61.6717 59.8004C64.8275 53.8163 68.0122 47.846 71.226 41.8896C72.1535 40.1752 73.081 38.4608 74.0085 36.7465C74.0919 36.594 73.8589 36.4588 73.7754 36.6078C70.5292 42.5619 67.3213 48.5322 64.1516 54.5186C63.2403 56.2353 62.3337 57.9508 61.4317 59.6652C61.3517 59.8177 61.5813 59.9529 61.6647 59.8004H61.6717Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M74.1666 36.8712C69.2207 36.8989 64.2761 36.922 59.3325 36.9405L43.302 37.0133L35.372 37.0514C35.2971 37.0514 35.2363 37.1119 35.2363 37.1866C35.2363 37.2612 35.2971 37.3218 35.372 37.3218C40.3178 37.294 45.2625 37.2709 50.206 37.2524L66.2365 37.1797L74.1666 37.1415C74.2415 37.1415 74.3022 37.081 74.3022 37.0064C74.3022 36.9317 74.2415 36.8712 74.1666 36.8712Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M36.3098 36.3864C33.1239 42.4375 29.9044 48.4736 26.6512 54.4947C25.7237 56.2207 24.7893 57.9443 23.8479 59.6656C23.7644 59.8181 23.9974 59.9532 24.0809 59.8008C27.3549 53.7935 30.6011 47.7586 33.8195 41.6959C34.7331 39.9723 35.6444 38.2475 36.5533 36.5216C36.6368 36.3691 36.4038 36.2339 36.3203 36.3864H36.3098Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M41.5766 56.6503L47.0129 45.969L48.4771 43.0994C48.5571 42.9469 48.3241 42.8083 48.2441 42.9642L42.634 53.9505L41.3297 56.4978C41.2532 56.6538 41.4862 56.789 41.5627 56.633L41.5766 56.6503Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M28.6721 56.6949L31.8024 50.5606C31.8789 50.4046 31.6458 50.2694 31.5693 50.4219L28.439 56.5597C28.3625 56.7157 28.5956 56.8508 28.6721 56.6949Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M59.5303 56.6507C62.1354 51.9685 64.4344 47.1235 66.9039 42.3685C67.509 41.204 68.1212 40.0395 68.7612 38.9028C68.8446 38.7503 68.6116 38.6151 68.5281 38.7676C65.923 43.4463 63.6205 48.2949 61.1546 53.0464C60.5494 54.2143 59.9372 55.3753 59.2973 56.5121C59.2138 56.6611 59.4433 56.7997 59.5303 56.6472V56.6507Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M45.2417 56.6154C47.6068 51.9818 49.9962 47.355 52.3544 42.7179L53.1544 41.1445L53.5856 40.2954L53.7978 39.8726C53.8569 39.7582 53.9474 39.4394 54.0656 39.377C54.2398 39.3526 54.4166 39.3526 54.5908 39.377H55.2551H56.6777C58.7947 39.3562 60.9105 39.3389 63.0252 39.325C65.1642 39.325 67.2997 39.3077 69.4388 39.3458C69.5045 39.3352 69.5528 39.2787 69.5528 39.2124C69.5528 39.146 69.5045 39.0895 69.4388 39.0789C64.2808 38.9888 59.1193 39.0789 53.9647 39.1378C53.9164 39.1372 53.8713 39.1623 53.8465 39.2037C50.9319 44.988 47.9546 50.741 45.0087 56.508C44.9287 56.6639 45.1617 56.7991 45.2417 56.6432V56.6154Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M59.5555 56.5501C58.286 51.9926 56.773 47.5045 55.3192 43.0061C54.9087 41.7399 54.5006 40.4749 54.0949 39.2111C54.0427 39.0447 53.7818 39.1141 53.834 39.2804C55.3052 43.8933 56.8495 48.4853 58.2651 53.1155C58.6129 54.28 58.9607 55.448 59.3085 56.6228C59.3317 56.6908 59.4042 56.7289 59.4735 56.7095C59.5429 56.6902 59.585 56.6201 59.5694 56.5501H59.5555Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M68.6883 39.0893C65.8154 41.5153 62.7338 43.664 59.6626 45.8197C56.3376 48.1521 52.9847 50.443 49.7188 52.8517C48.105 54.0404 46.5085 55.2569 44.9782 56.5496C44.846 56.6605 45.0373 56.8511 45.1694 56.7402C48.098 54.2691 51.2352 52.0511 54.369 49.8469C57.6697 47.5248 61.0052 45.2479 64.2607 42.86C65.8328 41.7094 67.391 40.531 68.8796 39.2799C69.0118 39.1656 68.8205 38.9784 68.6883 39.0893Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M44.7351 56.5774C48.714 56.6918 52.693 56.7368 56.6719 56.7403C57.6318 56.7403 58.5953 56.7403 59.5552 56.7195C59.6209 56.7089 59.6692 56.6524 59.6692 56.5861C59.6692 56.5198 59.6209 56.4632 59.5552 56.4526C55.5659 56.5289 51.5556 56.4526 47.5767 56.3764C46.6306 56.3556 45.6811 56.3383 44.7351 56.3105C44.6694 56.3211 44.6211 56.3777 44.6211 56.444C44.6211 56.5103 44.6694 56.5668 44.7351 56.5774Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M39.2202 56.7408C41.7557 52.0378 44.0895 47.2378 46.5485 42.4898C47.1537 41.3161 47.7682 40.147 48.3919 38.9825C48.4719 38.83 48.2389 38.6948 48.1589 38.8473C45.6234 43.5503 43.2896 48.3503 40.8306 53.0983C40.2254 54.2732 39.6167 55.4446 38.9872 56.6056C38.9072 56.7581 39.1402 56.8933 39.2202 56.7408Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M31.7322 56.6814C33.3182 53.5761 34.9066 50.472 36.4972 47.369C37.2902 45.8164 38.0832 44.2637 38.8762 42.7111C39.2658 41.9521 39.6519 41.1896 40.0379 40.4306C40.1631 40.1811 40.3544 39.5503 40.6257 39.4429C40.8562 39.4071 41.0909 39.4071 41.3213 39.4429H42.0935C44.1108 39.4083 46.1315 39.3701 48.1523 39.4429C48.3227 39.4429 48.3227 39.1795 48.1523 39.1726C45.589 39.0929 43.0256 39.1726 40.4657 39.2107C40.4173 39.2101 40.3723 39.2352 40.3475 39.2766C37.4224 45.0539 34.4556 50.8139 31.5096 56.5809C31.4296 56.7334 31.6627 56.872 31.7427 56.716L31.7322 56.6814Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M39.242 56.6748C39.7602 50.8905 40.0524 45.0924 40.588 39.3116C40.6054 39.1383 40.3376 39.1383 40.3202 39.3116C39.7846 45.0924 39.4924 50.8905 38.9707 56.6748C38.9707 56.8446 39.2246 56.8446 39.242 56.6748Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M48.1909 39.1759C43.8781 43.8131 39.3983 48.2908 35.0194 52.862C33.8253 54.1028 32.6427 55.3539 31.4717 56.6154C31.3535 56.7402 31.5448 56.9308 31.663 56.8025C36.0002 52.1238 40.5148 47.608 44.9354 43.0055C46.0948 41.7995 47.2437 40.5865 48.3822 39.3665C48.5005 39.2418 48.3092 39.0512 48.1909 39.1759Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M31.399 56.6498C33.9623 56.7746 36.5396 56.8855 39.1064 56.8127C39.2803 56.8127 39.2803 56.5389 39.1064 56.5458C36.5396 56.6151 33.9623 56.5077 31.399 56.3829C31.2251 56.3829 31.2251 56.6429 31.399 56.6498Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M35.5354 40.7322C35.4055 40.9463 35.3666 41.2033 35.4276 41.4461C35.4936 41.6523 35.662 41.8097 35.8728 41.862C36.3884 41.946 36.9145 41.7945 37.3058 41.4496C37.7131 41.1534 37.9433 40.6726 37.9179 40.1707C37.8586 39.7493 37.4812 39.4461 37.0553 39.4776C36.7581 39.5113 36.4828 39.6503 36.2797 39.8692C36.167 39.9729 36.0601 40.0828 35.9597 40.1985C35.8632 40.295 35.7926 40.4142 35.7545 40.545C35.7232 40.7149 35.9841 40.7876 36.0154 40.6178C36.0467 40.448 36.2415 40.2712 36.3632 40.1499C36.4998 39.9969 36.6652 39.8721 36.8501 39.7826C36.9978 39.7168 37.1667 39.7171 37.3142 39.7833C37.4617 39.8495 37.5738 39.9753 37.6223 40.1291C37.6826 40.4969 37.5516 40.8701 37.2745 41.1203C36.9804 41.4254 36.5846 41.6128 36.1615 41.6471C35.988 41.6717 35.8142 41.6048 35.7024 41.4704C35.6145 41.2817 35.6316 41.0611 35.7476 40.8881C35.8276 40.7356 35.5945 40.6005 35.5145 40.753L35.5354 40.7322Z",
    fill: "#83FFA3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    opacity: 0.2,
    d: "M96.6217 28.5187L75.1827 69.2547H0.518555L21.9679 28.5187H43.3686L32.4613 33.4989H32.437C26.872 35.5195 22.4236 38.6143 20.1489 42.4786C14.9318 51.33 23.1296 60.8469 38.4436 63.765C53.7577 66.6831 70.3899 61.845 75.5966 52.9936C76.6832 51.2238 77.2249 49.1754 77.1548 47.1019L78.2782 28.4979L96.6217 28.5187Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M28.9644 21.6732C28.0606 23.2557 27.1428 24.897 26.267 26.521C25.3911 28.145 24.5222 29.7828 23.8033 31.4172C23.6149 31.8258 23.4544 32.2309 23.2869 32.636C23.2694 32.6741 23.2869 32.636 23.2869 32.636C23.2869 32.636 23.2869 32.6637 23.2659 32.6914C23.2536 32.7949 23.2536 32.8995 23.2659 33.0031C23.3307 33.3403 23.4374 33.6683 23.5835 33.9795C23.744 34.3258 23.9324 34.7101 24.1453 35.0806C25.0842 36.6222 26.1265 38.0995 27.265 39.5025L25.904 40.9395C24.2844 39.761 22.8253 38.3794 21.563 36.8293C20.831 35.954 20.2647 34.9545 19.8915 33.8791C19.781 33.5271 19.713 33.1633 19.6891 32.7953C19.6774 32.5781 19.6844 32.3603 19.7101 32.1443C19.7221 32.0279 19.7408 31.9123 19.7659 31.7981C19.7659 31.7392 19.7973 31.6769 19.8113 31.618L19.8566 31.4622C20.0171 30.9843 20.1707 30.4996 20.3452 30.0356C21.029 28.2161 21.8094 26.4338 22.6832 24.6961C23.5591 22.9648 24.4698 21.3062 25.4748 19.6372L28.9644 21.6732Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M26.7556 39.0448L28.612 39.6473L27.0522 42.2581C27.0522 42.2581 25.6843 41.6453 25.4121 40.4022L26.7556 39.0448Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M31.1534 40.6586L29.3423 42.6704L27.0566 42.2618L28.6165 39.651L31.1534 40.6586Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M39.8039 9.52287C39.7516 9.72717 39.8039 9.92108 39.954 9.95571C40.104 9.99033 40.2401 9.85183 40.3029 9.64753C40.3657 9.44323 40.3029 9.24586 40.1529 9.21124C40.0028 9.17661 39.8563 9.31512 39.8039 9.52287Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M39.802 9.91724C39.8865 10.6067 40.0662 11.2813 40.3359 11.9221C39.9945 12.0556 39.6108 12.0315 39.2891 11.8563L39.802 9.91724Z",
    fill: "#ED847E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M39.3449 8.18948C39.2991 8.16966 39.2695 8.1248 39.2695 8.07521C39.2695 8.02563 39.2991 7.98076 39.3449 7.96094C39.7174 7.80492 40.1431 7.8385 40.486 8.05097C40.5416 8.09255 40.5553 8.16964 40.5174 8.22757C40.4768 8.28269 40.3989 8.29504 40.343 8.25527C40.068 8.09158 39.7307 8.06841 39.4357 8.19294C39.4062 8.20377 39.3735 8.20253 39.3449 8.18948Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M32.6885 10.3257C33.0689 12.2475 33.4492 15.769 32.0918 17.0502C32.0918 17.0502 32.6222 19.0031 36.22 19.0031C40.1806 19.0031 38.1148 17.0502 38.1148 17.0502C35.9513 16.5412 36.021 14.9483 36.37 13.4559L32.6885 10.3257Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M31.4321 18.0407C31.2471 17.0019 31.0412 15.8246 31.7252 15.5234C32.4754 15.1771 36.4187 15.1563 37.6923 16.0289C38.966 16.9015 38.3903 18.9099 38.3903 18.9099L31.4321 18.0407Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    opacity: 0.6,
    d: "M31.4321 18.0407C31.2471 17.0019 31.0412 15.8246 31.7252 15.5234C32.4754 15.1771 36.4187 15.1563 37.6923 16.0289C38.966 16.9015 38.3903 18.9099 38.3903 18.9099L31.4321 18.0407Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4545 106.397C19.2484 106.544 19.0105 106.562 18.795 106.448C18.5688 106.378 18.3487 106.27 18.139 106.128C18.1158 106.115 18.1005 106.082 18.1006 106.046C18.1028 106.01 18.119 105.978 18.1425 105.965C18.1774 105.939 19.0044 105.451 19.3533 105.7C19.4323 105.751 19.4922 105.85 19.5174 105.97C19.5622 106.117 19.5368 106.29 19.4545 106.397ZM19.2988 105.869L19.2255 105.833V105.859C18.9193 105.824 18.6117 105.89 18.3252 106.052C18.7021 106.256 19.229 106.434 19.3721 106.256C19.393 106.24 19.4279 106.189 19.393 106.027C19.379 105.956 19.3445 105.899 19.2988 105.869Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1719 105.974H18.144C18.1325 105.972 18.1216 105.967 18.1126 105.96C18.0955 105.944 18.0888 105.92 18.0951 105.898C18.0955 105.897 18.096 105.895 18.0968 105.893C18.1205 105.82 18.3438 105.134 18.6814 104.959C18.7674 104.914 18.8686 104.907 18.9605 104.939C19.0557 104.959 19.1232 105.043 19.1211 105.139C19.1141 105.437 18.472 105.887 18.1719 105.974ZM18.9185 105.042H18.901C18.8476 105.028 18.7907 105.033 18.7405 105.056C18.5084 105.249 18.3406 105.507 18.2589 105.797C18.5695 105.651 18.9952 105.298 18.9952 105.122C18.9952 105.104 18.9952 105.066 18.9185 105.042Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0998 107.455C38.9882 107.665 38.6706 107.733 38.3217 107.733C38.0537 107.73 37.7865 107.696 37.5225 107.631C37.4974 107.622 37.4783 107.593 37.4737 107.558C37.4688 107.521 37.4815 107.483 37.5051 107.465C37.5365 107.436 38.4612 106.699 38.9009 106.865C38.9846 106.892 39.0566 106.966 39.0998 107.07C39.1587 107.185 39.1587 107.34 39.0998 107.455ZM38.8628 107.017C38.8223 107.009 38.7812 107.009 38.7406 107.017H38.7302C38.3678 107.077 38.0172 107.235 37.6973 107.48C38.1893 107.578 38.8593 107.573 38.9849 107.334C39.0128 107.3 39.0303 107.246 38.9849 107.139C38.9577 107.077 38.9136 107.033 38.8628 107.017Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5469 107.401H37.5225C37.5096 107.403 37.4963 107.402 37.4841 107.397C37.4657 107.384 37.4563 107.361 37.4596 107.339C37.4596 107.311 37.519 106.601 37.8679 106.327C37.9644 106.246 38.0906 106.207 38.2169 106.22C38.3879 106.237 38.4507 106.324 38.4507 106.393C38.4995 106.708 37.8644 107.259 37.5469 107.401ZM38.2059 106.335H38.171C38.0907 106.335 38.013 106.363 37.9512 106.414C37.7542 106.643 37.6324 106.926 37.6022 107.225C37.9303 107.027 38.3595 106.581 38.3316 106.404C38.3314 106.403 38.3312 106.403 38.331 106.402C38.3271 106.385 38.3156 106.335 38.2059 106.335Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M34.6113 107.339H37.2599L37.5216 101.252H34.8765L34.6113 107.339Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M15.2012 105.275L17.7869 105.833L20.3867 100.165L17.7974 99.6071L15.2012 105.275Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M18.0389 105.573L15.1286 104.95C15.0229 104.927 14.9155 104.981 14.8704 105.078L13.8619 107.249C13.8128 107.357 13.8159 107.481 13.8702 107.586C13.9246 107.691 14.0243 107.766 14.1411 107.789C15.16 107.99 15.666 108.035 16.9327 108.312C17.7214 108.482 19.4976 108.911 20.5828 109.143C21.6681 109.375 22.045 108.34 21.6297 108.15C19.7314 107.287 18.9392 106.529 18.4228 105.823C18.3301 105.695 18.1935 105.607 18.0389 105.573Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M37.2424 107.035H34.3496C34.2414 107.034 34.1479 107.109 34.1263 107.215L33.6028 109.548C33.5759 109.663 33.6037 109.783 33.678 109.874C33.7523 109.966 33.8649 110.018 33.9832 110.016C35.0301 109.999 36.5341 109.94 37.8461 109.94C39.3781 109.94 40.7006 110.023 42.5012 110.023C43.5865 110.023 43.897 108.932 43.4329 108.832C41.3636 108.382 39.6712 108.333 37.881 107.239C37.691 107.114 37.4701 107.043 37.2424 107.035Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M42.5197 20.2256C43.3816 22.1543 44.3238 24.1349 45.3113 26.029C45.8033 26.9778 46.3163 27.9127 46.8467 28.7991C47.3595 29.6752 47.9259 30.5194 48.5427 31.3269L48.766 31.6039C48.8218 31.6558 48.766 31.6316 48.8532 31.6939C48.9925 31.8149 49.1419 31.9238 49.2999 32.0194C49.7188 32.2728 50.1509 32.504 50.5945 32.7119C51.5297 33.1586 52.5242 33.588 53.5327 33.9931C55.5462 34.8068 57.619 35.5859 59.6779 36.365L59.1754 38.2764C56.9414 37.9205 54.7282 37.4466 52.5452 36.8567C51.4495 36.5451 50.3537 36.2265 49.2475 35.8179C48.6656 35.6046 48.097 35.3572 47.5446 35.0769C47.2166 34.9082 46.9027 34.7136 46.6059 34.4952C46.4166 34.3539 46.2392 34.1976 46.0755 34.0277L45.751 33.6815C44.9543 32.7878 44.2276 31.8351 43.577 30.8317C42.9314 29.8656 42.3487 28.8788 41.7903 27.8815C40.6872 25.8963 39.6969 23.8512 38.8242 21.7561L42.5197 20.2256Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M26.5363 17.6458C24.0552 18.2103 19.8887 30.4403 19.8887 30.4403L23.9435 31.7769C23.9435 31.7769 28.0822 25.693 29.4885 22.774C30.9576 19.6888 29.0767 17.0676 26.5363 17.6458Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    opacity: 0.5,
    d: "M26.5363 17.6458C24.0552 18.2103 19.8887 30.4403 19.8887 30.4403L23.9435 31.7769C23.9435 31.7769 28.0822 25.693 29.4885 22.774C30.9576 19.6888 29.0767 17.0676 26.5363 17.6458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M24.6477 31.1782C24.6477 31.1782 20.6731 30.4268 19.7624 29.8658C19.4448 30.3229 19.0644 31.9781 19.3227 32.4663C19.5809 32.9545 23.2833 33.6575 23.7858 33.3701C24.2883 33.0827 24.6477 31.1782 24.6477 31.1782Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    opacity: 0.6,
    d: "M24.6477 31.1782C24.6477 31.1782 20.6731 30.4268 19.7624 29.8658C19.4448 30.3229 19.0644 31.9781 19.3227 32.4663C19.5809 32.9545 23.2833 33.6575 23.7858 33.3701C24.2883 33.0827 24.6477 31.1782 24.6477 31.1782Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    opacity: 0.3,
    d: "M28.1473 21.988C27.39 22.7394 26.7026 24.8724 26.6816 27.5837C27.5575 26.1986 28.4613 24.7131 29.0929 23.5255C28.7928 22.4555 28.4578 21.6903 28.1473 21.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M41.3728 17.7812C41.3728 17.7812 44.1923 20.9391 41.5298 40.4962H27.3657C27.268 38.3389 28.6324 27.8125 26.5352 17.6426C28.1013 17.3425 29.6854 17.1436 31.2775 17.0471C33.2835 16.9327 35.2945 16.9327 37.3005 17.0471C38.6751 17.1862 40.0367 17.4317 41.3728 17.7812Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    opacity: 0.5,
    d: "M41.3728 17.7812C41.3728 17.7812 44.1923 20.9391 41.5298 40.4962H27.3657C27.268 38.3389 28.6324 27.8125 26.5352 17.6426C28.1013 17.3425 29.6854 17.1436 31.2775 17.0471C33.2835 16.9327 35.2945 16.9327 37.3005 17.0471C38.6751 17.1862 40.0367 17.4317 41.3728 17.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    opacity: 0.3,
    d: "M39.2734 24.0269C39.5421 26.8801 41.3672 30.502 42.435 32.1433C42.5746 30.2596 42.6478 28.6183 42.6688 27.1848L39.2734 24.0269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M37.8656 19.8173C36.1592 23.0203 45.0681 33.436 45.0681 33.436L48.1808 30.3022C48.1808 30.3022 44.1399 23.2904 43.1907 20.1809C42.0182 16.3374 39.1637 17.3796 37.8656 19.8173Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    opacity: 0.5,
    d: "M37.8656 19.8173C36.1592 23.0203 45.0681 33.436 45.0681 33.436L48.1808 30.3022C48.1808 30.3022 44.1399 23.2904 43.1907 20.1809C42.0182 16.3374 39.1637 17.3796 37.8656 19.8173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M48.0563 29.682C48.0563 29.682 45.3554 32.6703 44.4062 33.1447C44.6366 33.6502 45.8614 34.8379 46.4232 34.876C46.985 34.9141 49.4975 32.1266 49.508 31.5518C49.5185 30.977 48.0563 29.682 48.0563 29.682Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    opacity: 0.6,
    d: "M48.0563 29.682C48.0563 29.682 45.3554 32.6703 44.4062 33.1447C44.6366 33.6502 45.8614 34.8379 46.4232 34.876C46.985 34.9141 49.4975 32.1266 49.508 31.5518C49.5185 30.977 48.0563 29.682 48.0563 29.682Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M59.0687 36.3998L61.6336 35.3021L62.4327 38.0722C62.4327 38.0722 60.475 39.343 58.9082 38.2315L59.0687 36.3998Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M64.494 36.6141C64.41 36.6697 64.2966 36.6481 64.2392 36.5657L61.3918 32.3759C61.3639 32.3361 61.3534 32.2868 61.3626 32.2393C61.3718 32.1917 61.3999 32.1498 61.4406 32.1231C61.4807 32.0955 61.5303 32.085 61.5783 32.0942C61.6262 32.1033 61.6684 32.1312 61.6954 32.1716L64.5428 36.3614C64.5707 36.4012 64.5812 36.4504 64.572 36.498C64.5628 36.5455 64.5347 36.5874 64.494 36.6141Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M64.3372 35.5066L65.4644 37.1617L62.4319 38.062L61.6328 35.2988L64.3372 35.5066Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    opacity: 0.2,
    d: "M37.523 101.255L37.3903 104.392H34.7383L34.8744 101.255H37.523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    opacity: 0.2,
    d: "M17.797 99.6095L20.3863 100.164L19.0463 103.086L16.457 102.529L17.797 99.6095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M33.018 7.32701C32.5225 9.88938 32.1003 11.3645 33.0494 12.985C34.4767 15.4088 37.9104 15.0626 39.1666 12.7045C40.3007 10.5784 40.9114 6.74875 38.692 5.11091C37.6974 4.37237 36.3883 4.19763 35.2323 4.64911C34.0764 5.10059 33.2385 6.11389 33.018 7.32701Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M32.0016 6.05986C33.8685 5.45389 37.4069 4.14847 38.6562 7.12982C39.9055 10.1112 34.8177 13.2241 33.5231 13.2276C32.4832 13.2379 29.9497 6.75239 32.0016 6.05986Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M35.8885 7.31673C39.5455 9.30775 42.8676 6.44414 41.3845 3.20655C39.9015 -0.031029 36.6597 0.43643 37.6682 2.0154C38.6766 3.59437 35.8885 1.20168 33.9622 1.93922C32.6118 2.45516 34.3635 3.29658 34.5276 3.90601C34.6916 4.51544 30.9926 4.53275 30.5006 5.44689C30.0086 6.36103 31.7848 8.26549 32.6955 7.9677C33.6063 7.66992 35.2429 6.96007 35.8885 7.31673Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M36.9443 8.85067C36.8237 9.48779 36.9194 10.1466 37.2165 10.724C37.6109 11.4788 38.2948 11.2538 38.5914 10.537C38.8601 9.88947 38.9753 8.71909 38.382 8.20316C37.7888 7.68722 37.0979 8.08543 36.9443 8.85067Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M36.5077 40.4963C36.5077 40.4963 33.5031 60.5797 31.8526 68.1006C30.045 76.3418 20.3859 102.751 20.3859 102.751L15.6436 101.733C15.6436 101.733 22.8774 77.0066 23.9068 68.8382C25.027 59.9842 27.3685 40.486 27.3685 40.486L36.5077 40.4963Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M21.5202 101.182C21.5411 101.182 20.6373 102.882 20.6373 102.882L15.3018 101.736L15.7519 100.147L21.5202 101.182Z",
    fill: "#83FFA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    opacity: 0.3,
    d: "M34.6075 47.6503C31.1179 48.3255 31.4983 61.1858 31.917 67.7994C32.9185 63.1249 34.3876 54.1289 35.3891 47.7438C35.1466 47.6263 34.8712 47.5933 34.6075 47.6503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M41.5219 40.4957C41.5219 40.4957 41.8709 60.1428 41.5987 68.1554C41.3056 76.49 38.3813 103.783 38.3813 103.783H33.8868C33.8868 103.783 33.7193 76.9783 33.5204 68.7925C33.304 59.8693 32.2188 40.4957 32.2188 40.4957L41.5219 40.4957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M39.2398 102.01C39.2608 102.01 38.9851 103.859 38.9851 103.859H33.5274L33.3809 102.211L39.2398 102.01Z",
    fill: "#83FFA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiit);
export default __webpack_public_path__ + "static/media/recruiit.f1834a5f5cb72a16ca5a68af419c8980.svg";
export { ForwardRef as ReactComponent };